/** iterates through a json string */
module.exports = function eachJSON(json, options) {
	if (!json) {
		return '';
	}

	let data;
	let list = {};

	try {
		list = typeof json === 'string' ? JSON.parse(json) : json;
	} catch (e) {
		console.log(e, json);
	}

	[].forEach.call(list, (item, index) => {
		data += options.fn(item, {
			data: {
				index,
				total: list.length,
			},
		});
	});

	return data;
};
